// Code generated by "typescripter -type=DatasetStatus -linecomment -output=../../portal/src/enums/datasetstatusenum.ts"; DO NOT EDIT.

export enum DatasetStatusEnum {
  DatasetStatusDatasetCreated = 'dataset_created',
  DatasetStatusOrderCanceled = 'order_canceled',
  DatasetStatusMetadataCustRequested = 'metadata_cust_requested',
  DatasetStatusMetadataCustRequestedBlocked = 'metadata_cust_requested_blocked',
  DatasetStatusMetadataDPRequested = 'metadata_dp_requested',
  DatasetStatusMetadataReady = 'metadata_ready',
  DatasetStatusMetadataStalled = 'metadata_stalled',
  DatasetStatusSamplesPacking = 'samples_packing',
  DatasetStatusSamplesPacked = 'samples_packed',
  DatasetStatusSampleEvaluating = 'samples_evaluating',
  DatasetStatusSampleEvaluated = 'samples_evaluated',
  DatasetStatusSamplesScanning = 'samples_scanning',
  DatasetStatusSamplesScanned = 'samples_scanned',
  DatasetStatusSamplesMarkedClean = 'samples_marked_clean',
  DatasetStatusSamplesClean = 'samples_clean',
  DatasetStatusSamplesPHIDetected = 'samples_phi_detected',
  DatasetStatusSamplesDelivering = 'samples_delivering',
  DatasetStatusSamplesDelivered = 'samples_delivered',
  DatasetStatusMetadataEmailSent = 'metadata_email_sent',
  DatasetStatusDatasetOrdered = 'dataset_ordered',
  DatasetStatusOrderDisapproved = 'order_dispproved',
  DatasetStatusSamplesRecalled = 'samples_recalled',
  DatasetStatusQuotesSent = 'quotes_sent',
  DatasetStatusQuotesSigned = 'quotes_signed',
  DatasetStatusNormalizingDicom = 'normalizing_dicom',
  DatasetStatusNormalizedDicom = 'normalized_dicom',
  DatasetStatusTriggeredDatasetPacking = 'triggered_dataset_packing',
  DatasetStatusDatasetPacking = 'dataset_packing',
  DatasetStatusDatasetPacked = 'dataset_packed',
  DatasetStatusDatasetEvaluating = 'dataset_evaluating',
  DatasetStatusDatasetEvaluated = 'dataset_evaluated',
  DatasetStatusDatasetScanning = 'dataset_scanning',
  DatasetStatusDatasetScanned = 'dataset_scanned',
  DatasetStatusDatasetMarkedClean = 'dataset_marked_clean',
  DatasetStatusDatasetClean = 'dataset_clean',
  DatasetStatusDatasetPHIDetected = 'dataset_phi_detected',
  DatasetStatusDatasetDelivering = 'dataset_delivering',
  DatasetStatusDatasetDelivered = 'dataset_delivered',
  DatasetStatusDeliveryEmailSent = 'delivery_email_sent',
  DatasetStatusDatasetRecalled = 'dataset_recalled',
  DatasetStatusOrderFullfilled = 'order_fullfilled',
  DatasetStatusV2Processing = 'v2_processing',
  DatasetStatusRequestedPriorityUpdate = 'requested_priority_update',
  DatasetStatusRequestedOrderCanceled = 'requested_order_canceled',
  DatasetStatusDatasetNoZipToScan = 'dataset_no_zip_to_scan',
  DatasetStatusDatasetNoZipToDeliver = 'dataset_no_zip_to_deliver',
  DatasetStatusSamplesNoZipToScan = 'samples_no_zip_to_scan',
  DatasetStatusSamplesNoZipToDeliver = 'samples_no_zip_to_deliver',
  DatasetStatusSamplesToScanV2 = 'samples_to_scan_v2',
  DatasetStatusSamplesToDeliverV2 = 'samples_to_deliver_v2',
  DatasetStatusSamplesParentWait = 'samples_parent_wait',
  DatasetStatusDatasetToScanV2 = 'dataset_to_scan_v2',
  DatasetStatusDatasetToDeliverV2 = 'dataset_to_deliver_v2',
  DatasetStatusDatasetParentWait = 'dataset_parent_wait',
  DatasetStatusMetadataCustRequestedV2 = 'metadata_cust_requested_v2',
}
